import React from "react";
import { Circle } from "../../components/Animation";
import { Request } from "../../hooks/Request";
import { Page, Document, PDFViewer, Image, View, Text, StyleSheet } from "@react-pdf/renderer";
import * as dayjs from "dayjs";
import { useAuth } from "../../contexts/AuthContext";
import "dayjs/locale/es";

dayjs.locale("es");

const PRIMARY = "#008f83";
const PRIMARY_DARK = "#00665c";
const LIGHT_BG = "#e6f5f4";
const TABLE_BORDER = "#008f83";

const s = StyleSheet.create({
  page: {
    padding: "25px 30px 60px 30px",
    fontFamily: "Helvetica",
    fontSize: 9,
    color: "#1a1a1a",
    position: "relative",
  },
  /* ── Marca de agua ── */
  watermark: {
    position: "absolute",
    top: "30%",
    left: "15%",
    width: 400,
    height: 400,
    opacity: 0.08,
  },
  /* ── Header superior ── */
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 4,
  },
  logo: {
    height: 100,
    width: 220,
    objectFit: "contain",
  },
  dateRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  dateLabel: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    color: "#000000",
    marginRight: 6,
  },
  dateValue: {
    fontSize: 9,
    color: "#000000",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    paddingBottom: 2,
    minWidth: 160,
    textAlign: "center",
  },
  /* ── Título ── */
  titleContainer: {
    alignItems: "center",
    marginTop: 4,
    marginBottom: 8,
  },
  title: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
    color: PRIMARY,
    letterSpacing: 1,
  },
  titleLine: {
    height: 1.5,
    backgroundColor: PRIMARY,
    width: "100%",
    marginTop: 3,
  },
  /* ── Campos de datos ── */
  fieldRow: {
    flexDirection: "row",
    paddingVertical: 1.5,
    alignItems: "flex-end",
  },
  fieldLabel: {
    width: "14%",
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: "#1a1a1a",
    paddingRight: 4,
  },
  fieldValue: {
    width: "86%",
    fontSize: 8,
    borderBottomWidth: 0.5,
    borderBottomColor: PRIMARY,
    borderBottomStyle: "dotted",
    paddingBottom: 1,
    color: "#1a1a1a",
  },
  /* ── Detalle ── */
  detalleRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 6,
    marginBottom: 8,
  },
  detalleLabel: {
    width: "14%",
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
  },
  detalleBox: {
    borderWidth: 1.5,
    borderColor: PRIMARY,
    paddingVertical: 3,
    paddingHorizontal: 12,
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
  },
  /* ── Tabla principal ── */
  table: {
    borderWidth: 1.5,
    borderColor: TABLE_BORDER,
    marginTop: 2,
  },
  tableHeaderBanner: {
    backgroundColor: LIGHT_BG,
    borderBottomWidth: 1.5,
    borderBottomColor: TABLE_BORDER,
    alignItems: "center",
    paddingVertical: 4,
  },
  tableHeaderBannerText: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    color: "#1a1a1a",
  },
  tableColumnHeaders: {
    flexDirection: "row",
    borderBottomWidth: 1.5,
    borderBottomColor: TABLE_BORDER,
  },
  thCell: {
    fontFamily: "Helvetica-Bold",
    fontSize: 8,
    textAlign: "center",
    paddingVertical: 3,
    paddingHorizontal: 2,
  },
  tdCell: {
    fontSize: 8,
    paddingVertical: 3,
    paddingHorizontal: 3,
  },
  tableRow: {
    flexDirection: "row",
    minHeight: 16,
  },
  tableRowBorder: {
    borderBottomWidth: 0.5,
    borderBottomColor: TABLE_BORDER,
  },
  cellBorderRight: {
    borderRightWidth: 1,
    borderRightColor: TABLE_BORDER,
  },
  /* Anchos de columna */
  colNum: { width: "6%" },
  colFojas: { width: "12%" },
  colEstado: { width: "18%" },
  colDescripcion: { width: "42%" },
  colNroDoc: { width: "22%" },
  /* ── Footer tabla ── */
  tableFooter: {
    flexDirection: "row",
    borderTopWidth: 1.5,
    borderTopColor: TABLE_BORDER,
    backgroundColor: LIGHT_BG,
  },
  tableFooterLabel: {
    width: "78%",
    fontFamily: "Helvetica-Bold",
    fontSize: 9,
    textAlign: "center",
    paddingVertical: 4,
    borderRightWidth: 1,
    borderRightColor: TABLE_BORDER,
  },
  tableFooterValue: {
    width: "22%",
    fontFamily: "Helvetica-Bold",
    fontSize: 9,
    textAlign: "center",
    paddingVertical: 4,
  },
  /* ── Firmas ── */
  signaturesRow: {
    position: "absolute",
    bottom: 80,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-around",
  },
  signatureBlock: {
    width: "35%",
    alignItems: "center",
  },
  signatureLine: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    width: "100%",
    marginBottom: 4,
  },
  signatureLabel: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
  },
  /* ── Footer página ── */
  pageFooter: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    borderTopWidth: 0.5,
    borderTopColor: "#cccccc",
    paddingTop: 6,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  footerTextBlock: {
    width: "82%",
  },
  footerText: {
    fontSize: 6.5,
    color: "#555",
  },
  footerLogoBlock: {
    width: "18%",
    alignItems: "flex-end",
  },
  footerLogo: {
    height: 25,
    objectFit: "contain",
  },
});



const RenderConstanciaEntrega = (props) => {
  const { procedure } = props;
  const { user } = useAuth?.() || {
    user: { user: { name: "Usuario", fatherLastName: "", motherLastName: "" } },
  };

  const fieldnames = [
    "destinatario",
    "codigoDeInterno",
    "nroDeInterno",
    "a1NúmeroDeDeclaración",
    "descripciónDeLaMercancía",
    "documentosSeccionL",
    "documentosSoporteDeLaDim",
    "facturacion",
  ];
  
  const params = new URLSearchParams();
  fieldnames.forEach(name => params.append('fieldnames', name));

  const { data: backendData, loading } = Request({
    urlApi: `/Procedure/${procedure.id || procedure.procedureId}/dataValues?${params.toString()}`,
  });

  if (!loading) {
    return (
      <div className="p-10 flex flex-col items-center">
        <Circle />
        <p className="mt-4 text-gray-500">Obteniendo datos del servidor...</p>
      </div>
    );
  }

  const data = backendData || {};

  const seccionLRaw = data.documentosSeccionLSubDatas || [];
  const soporteDimRaw = data.documentosSoporteDeLaDimSubDatas || [];
  const facturacionRaw = data.facturacionFileStates || [];

  const seccionL = Array.isArray(seccionLRaw) ? seccionLRaw : [seccionLRaw];
  const soporteDim = Array.isArray(soporteDimRaw) ? soporteDimRaw : [soporteDimRaw];
  const facturacion = Array.isArray(facturacionRaw) ? facturacionRaw : [facturacionRaw];

  const mapDocument = (item) => ({
    cantidadFojas: (() => {
      try {
        const val = JSON.parse(item.details)?.det_CantidadFojas;
        return (val === "" || val === null || val === undefined) ? 0 : val;
      } catch {
        return 0;
      }
    })(),
    estado: item.description5 || "",
    descripcion: item.label || "",
    nroDoc: item.description2 || "S/N",
  });

  const soporteDimDocs = soporteDim
    .filter(item => item)
    .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER))
    .map(mapDocument);
  const seccionLDocs = seccionL.filter(item => item).map(mapDocument);

  const facturacionDocs = facturacion.filter(item => item).map((item) => ({
    cantidadFojas: 1,
    estado: item.status || "",
    descripcion: item.name || "",
    nroDoc: item.number || "S/N",
  }));

  const allDocs = [...soporteDimDocs, ...facturacionDocs, ...seccionLDocs];

  const totalFojas = allDocs.reduce((acc, doc) => {
    const val = parseInt(doc.cantidadFojas, 10);
    return acc + (isNaN(val) ? 1 : val);
  }, 0);


  const logoUrl = user?.institutionParam?.find((d) => d.code === "logo")?.value ?? "";

  /* ── Componente de fila de campo ── */
  const FieldRow = ({ label, value }) => (
    <View style={s.fieldRow}>
      <Text style={s.fieldLabel}>{label}</Text>
      <Text style={s.fieldValue}>{value}</Text>
    </View>
  );

  /* ── Celda de tabla ── */
  const TdCell = ({ children, style: cellStyle, isLast }) => (
    <View style={[!isLast && s.cellBorderRight, cellStyle]}>
      <Text style={[s.tdCell, cellStyle?.textAlign ? { textAlign: cellStyle.textAlign } : {}]}>
        {children}
      </Text>
    </View>
  );

  const MyDoc = (
    <Document>
      <Page size="A4" style={s.page}>
        {/* ── Marca de agua ── */}
        {logoUrl ? (
          <Image src={logoUrl} style={s.watermark} />
        ) : null}

        {/* ── Header: Logo + Fecha ── */}
        <View style={s.headerRow}>
          <View style={{ width: "30%", marginLeft: -55 }}>
            {logoUrl ? (
              <Image src={logoUrl} style={s.logo} />
            ) : null}
          </View>
          <View style={{ width: "70%", alignItems: "flex-end" }}>
            <View style={s.dateRow}>
              <Text style={s.dateLabel}>FECHA:</Text>
              <Text style={s.dateValue}>
                {dayjs().format("dddd, DD [de] MMMM [de] YYYY")}
              </Text>
            </View>
          </View>
        </View>

        {/* ── Título ── */}
        <View style={s.titleContainer}>
          <Text style={s.title}>CONSTANCIA DE ENTREGA</Text>
          <View style={s.titleLine} />
        </View>

        {/* ── Campos de datos del trámite ── */}
        <View style={{ marginBottom: 4 }}>
          <FieldRow label="A:" value={data.destinatario || ""} />
          <FieldRow label="DE:" value="ACIABOL AGENCIA DESPACHANTE DE ADUANAS S.R.L." />
          <FieldRow label="REFERENCIA:" value="ENTREGA DE DOCUMENTOS" />
          <FieldRow label="INTERNO:" value={data.nroDeInterno || ""} />
          <FieldRow label="DIM:" value={data.a1NúmeroDeDeclaración || ""} />
          <FieldRow label="CONSIGNATARIO:" value={data.company?.razonSocial || ""} />
          <FieldRow label="MERCANCIA:" value={data.descripciónDeLaMercancía || ""} />
        </View>

        {/* ── Detalle ── */}
        <View style={s.detalleRow}>
          <Text style={s.detalleLabel}>DETALLE</Text>
          <Text style={s.detalleBox}>1  LEGAJO</Text>
        </View>

        {/* ══════ Tabla de documentos ══════ */}
        <View style={s.table}>
          {/* Banner superior */}
          <View style={s.tableHeaderBanner}>
            <Text style={s.tableHeaderBannerText}>
              SE REALIZA LA ENTREGA DE LA SIGUIENTE DOCUMENTACIÓN
            </Text>
          </View>

          {/* Encabezados de columna */}
          <View style={s.tableColumnHeaders}>
            <View style={[s.colNum, s.cellBorderRight]}>
              <Text style={s.thCell}>Nº</Text>
            </View>
            <View style={[s.colFojas, s.cellBorderRight]}>
              <Text style={s.thCell}>CANTIDAD{"\n"}FOJAS</Text>
            </View>
            <View style={[s.colEstado, s.cellBorderRight]}>
              <Text style={s.thCell}>ESTADO</Text>
            </View>
            <View style={[s.colDescripcion, s.cellBorderRight]}>
              <Text style={s.thCell}>DESCRIPCIÓN</Text>
            </View>
            <View style={s.colNroDoc}>
              <Text style={s.thCell}>Nº DOC</Text>
            </View>
          </View>

          {/* Filas con datos */}
          {allDocs.map((doc, index) => (
            <View
              key={index}
              style={[s.tableRow, s.tableRowBorder]}
            >
              <View style={[s.colNum, s.cellBorderRight]}>
                <Text style={[s.tdCell, { textAlign: "center" }]}>{index + 1}</Text>
              </View>
              <View style={[s.colFojas, s.cellBorderRight]}>
                <Text style={[s.tdCell, { textAlign: "center" }]}>{doc.cantidadFojas}</Text>
              </View>
              <View style={[s.colEstado, s.cellBorderRight]}>
                <Text style={[s.tdCell, { textAlign: "center" }]}>{doc.estado}</Text>
              </View>
              <View style={[s.colDescripcion, s.cellBorderRight]}>
                <Text style={s.tdCell}>{doc.descripcion}</Text>
              </View>
              <View style={s.colNroDoc}>
                <Text style={s.tdCell}>{doc.nroDoc}</Text>
              </View>
            </View>
          ))}


          {/* Footer de tabla: Total */}
          <View style={s.tableFooter}>
            <Text style={s.tableFooterLabel}>TOTAL FOJAS ENTREGADO</Text>
            <Text style={s.tableFooterValue}>{totalFojas}</Text>
          </View>
        </View>

        {/* ── Firmas ── */}
        <View style={s.signaturesRow}>
          <View style={s.signatureBlock}>
            <View style={s.signatureLine} />
            <Text style={s.signatureLabel}>ENTREGADO</Text>
          </View>
          <View style={s.signatureBlock}>
            <View style={s.signatureLine} />
            <Text style={s.signatureLabel}>RECIBIDO</Text>
          </View>
        </View>

        {/* ── Footer de página ── */}
        <View style={s.pageFooter} fixed>
          <View style={s.footerTextBlock}>
            <Text style={s.footerText}>
              Ubicación: Avenida 20 de Octubre esquina Landaeta Edificio Malaga Piso 2 Of.   ACIABOL Agencia despachante
            </Text>
            <Text style={s.footerText}>
              Teléfono:    2203462          Cel:
            </Text>
            <Text style={s.footerText}>
              email:    gerencia@aciabol.com
            </Text>
          </View>
          <View style={s.footerLogoBlock}>
            {logoUrl ? (
              <Image src={logoUrl} style={s.footerLogo} />
            ) : null}
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div>
      <PDFViewer style={{ width: 900, height: window.innerHeight - 100 }}>
        {MyDoc}
      </PDFViewer>
    </div>
  );
};

export default RenderConstanciaEntrega;
